import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        home: 'Home',
        projects: 'Projects',
        about: 'About Me',
        adminLogin: 'Admin Login',
        featuredProjects: 'Featured Projects',
        aboutMe: 'About Me',
        communityFeedback: 'Community Feedback',
        downloadCV: 'Download CV',
        skills: 'Skills',
        allProjects: 'All Projects',
        comments: 'Comments',
        viewDetails: 'View Details',
        viewOnGitHub: 'View on GitHub',
        leaveComment: 'Leave a Comment',
        submitComment: 'Submit Comment',
        noComments: 'No comments yet.',
        addComment: 'Add a comment...',
        commentingAs: 'Commenting as',
        downloadResume: 'Download Resume',
        letsConnect: "Let's connect",
        hiThere: 'Hi there,',
        myNameIs: 'My name is',
        iAmA: 'I am a',
        fullStackDeveloper: 'Full-Stack Developer',
        whereIdeasComeToLife: 'Where ideas come to life through code and creativity.',
        loadingProjects: 'Loading projects...',
        hideComments: 'Hide Comments',
        loadingComments: 'Loading comments...',
        yourName: "Your Name",
        namePlaceholder: "Enter your name",
        yourEmail: "Your Email",
        emailPlaceholder: "Enter your email",
        yourMessage: "Your Message",
        messagePlaceholder: "Type your message here...",
        send: "Send Message",
        appointment: 'Book a Meeting',
        bookAppointment: 'Book an Appointment',
        bookAppointmentSubtitle: 'Pick a day, then a 30-minute slot that works for you.',
        welcomeClient: 'Welcome, {name}!',
        invalidBookingLink: 'This booking link is invalid or has already been used.',
        selectDate: 'Select a date',
        selectTime: 'Select a time',
        pickDateFirst: 'Pick a date to see the available times.',
        noSlotsLeft: 'No slots left on this day.',
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        yourDetails: 'Your details',
        appointmentNotes: 'What would you like to talk about? (optional)',
        appointmentNotesPlaceholder: 'A few words about your project...',
        confirmAppointment: 'Confirm Appointment',
        appointmentConfirmed: 'Your appointment is booked!',
        confirmationEmailSent: 'A confirmation was sent to {email}.',
        slotTaken: 'Sorry, this slot was just taken. Please pick another one.',
        bookingFailed: 'Booking failed. Please try again later.'
    },
    fr: {
        home: 'Accueil',
        projects: 'Projets',
        about: 'À propos de moi',
        adminLogin: 'Connexion Admin',
        featuredProjects: 'Projets en vedette',
        aboutMe: 'À propos de moi',
        communityFeedback: 'Retour de la communauté',
        downloadCV: 'Télécharger le CV',
        skills: 'Compétences',
        allProjects: 'Tous les projets',
        comments: 'Commentaires',
        viewDetails: 'Voir les détails',
        viewOnGitHub: 'Voir sur GitHub',
        leaveComment: 'Laisser un commentaire',
        submitComment: 'Soumettre un commentaire',
        noComments: 'Pas encore de commentaires.',
        addComment: 'Ajouter un commentaire',
        commentingAs: 'Commentaire en tant que',
        downloadResume: 'Télécharger le CV',
        letsConnect: 'Connectons-nous',
        hiThere: 'Bonjour,',
        myNameIs: 'Je m\'appelle',
        iAmA: 'Je suis un',
        fullStackDeveloper: 'Développeur Full-Stack',
        whereIdeasComeToLife: 'Où les idées prennent vie grâce au code et à la créativité.',
        loadingProjects: 'Chargement des projets...',
        hideComments: 'Masquer les commentaires',
        loadingComments: 'Chargement des commentaires...',
        yourName: 'Votre nom',
        namePlaceholder: 'Entrez votre nom',
        yourEmail: 'Votre email',
        emailPlaceholder: 'Entrez votre email',
        yourMessage: 'Votre message',
        messagePlaceholder: 'Tapez votre message ici...',
        send: 'Envoyer le message',
        appointment: 'Prendre rendez-vous',
        bookAppointment: 'Prendre rendez-vous',
        bookAppointmentSubtitle: 'Choisissez un jour, puis un créneau de 30 minutes qui vous convient.',
        welcomeClient: 'Bienvenue, {name} !',
        invalidBookingLink: 'Ce lien de réservation est invalide ou a déjà été utilisé.',
        selectDate: 'Choisissez une date',
        selectTime: 'Choisissez une heure',
        pickDateFirst: 'Choisissez une date pour voir les heures disponibles.',
        noSlotsLeft: 'Plus aucun créneau disponible ce jour-là.',
        previousMonth: 'Mois précédent',
        nextMonth: 'Mois suivant',
        yourDetails: 'Vos coordonnées',
        appointmentNotes: 'De quoi aimeriez-vous parler ? (facultatif)',
        appointmentNotesPlaceholder: 'Quelques mots sur votre projet...',
        confirmAppointment: 'Confirmer le rendez-vous',
        appointmentConfirmed: 'Votre rendez-vous est réservé !',
        confirmationEmailSent: 'Une confirmation a été envoyée à {email}.',
        slotTaken: "Désolé, ce créneau vient d'être pris. Veuillez en choisir un autre.",
        bookingFailed: 'La réservation a échoué. Veuillez réessayer plus tard.'
    }
};

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages,
});

export default i18n;
